export default __webpack_public_path__ + "static/media/MVIMG_20190721_095858.c854b1ba.jpg";